<template>
  <div class="content-430">
    <div class="class-form-head">
      其他信息
    </div>
    <div class="class-form-content">
      <Form ref="materialInfo" :model="otherInfo" label-position="right" :label-width="120">
        <FormItem label="成本测量表">
          <div v-if="otherInfo.costFileLstShow" style="display:flex;align-items:center;">
            <span>{{ otherInfo.costFileLstShow.fileName }}</span>
            <!-- <a v-if="fileUrl" :href="fileUrl" target="_blank" rel="noopener noreferrer">下载</a> -->
            <span style="color:#5c45e5;cursor:pointer;" @click="handleDownFile">下载</span>
            <Icon type="ios-close" size="28" style="cursor: pointer;" @click="handleDeletFile"></Icon>
          </div>
          <UploadBtn
            v-if="uploadToken"
            :text="'上传文件'"
            class="upload"
            :upload-type="uploadType2"
            :can-upload-file="canUploadFile"
            @on-success="handleUploadFile"
          ></UploadBtn>
          <div>请上传课程成本测算表，支持格式：.rar .zip .doc .docx .pdf ，单个文件不能超过20MB</div>
        </FormItem>
      </Form>
    </div>
    <Modal
      v-model="modalShow"
      :width="800"
      :footer-hide="true"
      :closable="false"
      :mask-closable="false"
    >
      <Progress :percent="uploadPersent" :stroke-width="20" text-inside></Progress>
      <div class="cancel-box">
        <Button @click="handleCancelUpload">取消上传</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import UploadBtn from '@c/UploadBtn';
import axios from 'axios';
import cateringAdmin from '@/request/cateringAdmin/index';
import resourcesManagementApi from '@/request/courseCenter/resources';
export default {
  components: {
    UploadBtn
  },
  inject: ['EditCurriculumInstance'],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          costFileLst: ''
        };
      }
    }, // v-model的值
    theUserIdentity: {
      type: String,
      default: ''
    },
    courseId: {
      type: String,
      default: ''
    },
    uploadUrl: {
      type: String,
      default: ''
    },
    uploadToken: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      uploadType2: 1,
      canUploadFile: true, // 可以上传文件
      uploadPersent: 0, // 上传进度
      modalShow: false, // 进度条弹窗
      uploadType: '', // 上传类型
      source: null, // 上传的
      fileUrl: ''
    };
  },
  computed: {
    otherInfo: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    }
  },
  watch: {
    'otherInfo.costFileLst'(newVal) {
      if (newVal) {
        this.getFullUrl(newVal);
      }
    }
  },
  methods: {
    // 获取文件下载地址
    async getImgsrc(id) {
      const res = await cateringAdmin.getFileurl({ fileId: id });
      if (res.status === 200) {
        return `${res.message.downUrl}?fileId=${id}`;
      }
    },
    // 获取文件名
    async getFileInfoFun(id) {
      const res = await resourcesManagementApi.getFileInfo({
        fileId: id
      });
      if (res.status === 200) {
        return res.message.name;
      }
    },
    async getFullUrl(id) {
      const fullUrl = await this.getImgsrc(id);
      const showObj = { fileUrl: fullUrl, fileName: await this.getFileInfoFun(id) };
      this.$set(this.otherInfo, 'costFileLstShow', showObj);
    },
    handleDownFile() {
      this.courseDownload(this.otherInfo.costFileLstShow.fileUrl, this.otherInfo.costFileLstShow.fileName);
    },
    // 解决文件重命名失败问题
    courseDownload(url, filename) {
      this.getBlob(url, blob => {
        this.saveAs(blob, filename);
      });
    },
    getBlob(url, cb) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = function() {
        if (xhr.status === 200) {
          cb(xhr.response);
        }
      };
      xhr.send();
    },
    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement('a');
        var body = document.querySelector('body');

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        // fix Firefox
        link.style.display = 'none';
        body.appendChild(link);

        link.click();
        body.removeChild(link);

        window.URL.revokeObjectURL(link.href);
      }
    },
    // 删除文件
    handleDeletFile() {
      this.otherInfo = {
        costFileLst: '', // 成本测量表id
        costFileLstShow: null // 成本测量表全链接{fileUrl:'',fileName:''}
      };
    },
    async handleUploadFile(files) {
      if (!this.canUploadFile) {
        return;
      }
      const file = files[0];
      const typeArr = ['rar', 'zip', 'doc', 'docx', 'pdf'];
      if (file.size > 20480 * 1024) {
        this.$Message.warning('文件不能超过20MB！');
        return false;
      }
      const fileType = file.name.split('.');

      if (typeArr.indexOf(fileType[1]) === -1) {
        this.$Message.warning('文件不支持当前格式！');
        return false;
      }
      const name = file.name;
      this.canUploadFile = false;
      this.uploadType = 'doc';
      const id = await this.uploadImg(file);
      const fullUrl = await this.getImgsrc(id);
      this.otherInfo = {
        costFileLst: id, // 成本测量表id
        costFileLstShow: {
          fileUrl: fullUrl,
          fileName: name
        } // 成本测量表全链接{fileUrl:'',fileName:''}
      };
    },
    async uploadImg(ev) {
      return new Promise(async(resolve, reject) => {
        const file = ev;
        const formData = new FormData();
        formData.append('token', this.uploadToken);
        formData.append('file', file);
        const token = localStorage.getItem('loginToken');
        this.source = axios.CancelToken.source();
        var configs = {
          // 上传文件 请求头要设置成下面这样
          headers: {
            token: token,
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          onUploadProgress: progressEvent => {
            if (progressEvent.lengthComputable) {
              const val = (progressEvent.loaded / progressEvent.total * 100).toFixed(0);
              this.uploadPersent = parseInt(val);
            }
          },
          cancelToken: this.source.token
        };
        if (this.uploadType === 'doc') {
          this.modalShow = true;
        }
        axios.post(this.uploadUrl, formData, configs).then(res => {
          if (res.data.status === 200) {
            const id = res.data.message.fileId;
            this.canUploadFile = true;
            resolve(id);
          } else {
            this.canUploadFile = true;
            this.$Message.warning(res.data.error);
          }
        }).catch(err => {
          if (err.message) {
            this.$Message.error(err.message);
          }
        }).finally(() => {
          this.canUploadFile = true;
          this.modalShow = false;
          this.uploadType = '';
        });
      });
    },
    handleCancelUpload() {
      if (this.source) {
        this.source.cancel('用户取消上传'); // 这里传递的什么字符串，在上面的rej.message值就是什么
        this.uploadPersent = 0;
        this.canUploadFile = true;
        this.modalShow = false;
        this.uploadType = '';
      }
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
